//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

// TODO: Unify this and rights-request-actions
import { IContentLibraryItem } from '@apis/content-library/contentLibraryApiModel';
import { fullScreenWorkflowActions } from '@galleries/actions/fullScreenWorkflowActions';
import { FULLSCREEN_WORKFLOW_FLAGS } from '@galleries/models/fullScreenWorkflowModel';
import { galleriesDataActions } from '@galleries/reducers/galleriesDataSlice';
import { REQUEST_RIGHTS } from '@legacy-components/rights-management/request-rights-constants';
import { IRightsOption } from '@legacy-components/rights-management/request-rights-model';
import { ICuralateStore } from '@models/AppState';
import ClientId from '@models/ClientId';
import Cuid from '@models/Cuid';
import { getRightsManagementService } from '@react-bridge/wrappers/ng-service-provider';
import { createAction } from '@utils/actions';
import { ReduxDispatch } from 'app/curalate.store';

const fetchRightsConfigurations = () => {
  return createAction({
    type: REQUEST_RIGHTS.REQUEST_RIGHTS_CONFIGURATIONS,
  });
};

const receiveRightsConfigurations = (configurations: IRightsOption[]) => {
  return createAction({
    type: REQUEST_RIGHTS.RECEIVE_RIGHTS_CONFIGURATIONS,
    configurations,
  });
};

const selectConfigurationId = (configurationId: number) => {
  return createAction({
    type: REQUEST_RIGHTS.SELECT_CONFIGURATION_ID,
    configurationId,
  });
};

const selectMessageIndex = (index: number) => {
  return createAction({
    type: REQUEST_RIGHTS.SELECT_MESSAGE_INDEX,
    index,
  });
};

const graphRightsRequestStarted = () => {
  return createAction({
    type: REQUEST_RIGHTS.REQUEST_GRAPH_RIGHTS,
  });
};

const graphRightsRequestSucceeded = () => {
  return createAction({
    type: REQUEST_RIGHTS.REQUEST_GRAPH_RIGHTS_SUCCEEDED,
  });
};

const graphRightsRequestFailed = (error) => {
  return createAction({
    type: REQUEST_RIGHTS.REQUEST_GRAPH_RIGHTS_FAILED,
    error,
  });
};

export type RequestRightsAction = ReturnType<
  | typeof fetchRightsConfigurations
  | typeof receiveRightsConfigurations
  | typeof selectMessageIndex
  | typeof selectConfigurationId
  | typeof graphRightsRequestStarted
  | typeof graphRightsRequestSucceeded
  | typeof graphRightsRequestFailed
>;

export const requestRightsActions = {
  selectConfigurationId,
  selectMessageIndex,
  graphRightsRequestStarted,
  graphRightsRequestFailed,
  receiveRightsConfigurations,

  graphRightsRequestSucceeded:
    () => (dispatch: ReduxDispatch, getState: () => ICuralateStore) => {
      dispatch(graphRightsRequestSucceeded());
      dispatch(
        fullScreenWorkflowActions.setFlag(
          FULLSCREEN_WORKFLOW_FLAGS.RIGHTS_REQUESTED,
          true,
        ),
      );
      const clientId = ClientId.fromString(getState().session.client.id);

      const selectedItems =
        getState().galleries.requestRightsModal.selectedItems;
      Object.values<IContentLibraryItem>(selectedItems).forEach(
        (contentItem) => {
          const cuid = Cuid.build(contentItem, clientId);
          dispatch(galleriesDataActions.getGalleryItemByCuid(cuid));
        },
      );
    },

  requestRightsConfigurations: () => async (dispatch: ReduxDispatch) => {
    dispatch(fetchRightsConfigurations());
    const configurations =
      await getRightsManagementService().getRightsConfigurationsAsync({
        legacyReels: true,
      });
    dispatch(receiveRightsConfigurations(configurations));
  },
};
